import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  style: {"margin-bottom":"45px"},
  class: "upload-box has-files"
}
const _hoisted_2 = { class: "uploading-items" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "upload-file-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-file-upload" })
], -1)
const _hoisted_4 = { class: "upload-file-item-details" }
const _hoisted_5 = { class: "upload-file-item-title" }
const _hoisted_6 = {
  key: 0,
  class: "uploading-message"
}
const _hoisted_7 = { class: "uploading-message-inner" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_spinner = _resolveComponent("imdex-spinner")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h3", null, [
      _createTextVNode(_toDisplayString(_ctx.$t("import.uploadChild.filesUploading")) + "   ", 1),
      (!_ctx.uploadFinished)
        ? (_openBlock(), _createBlock(_component_imdex_spinner, {
            key: 0,
            width: "20",
            size: "2"
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadingFiles, (file, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["upload-file-item", {
						uploaded: file.progress == 1 && !file.hasError,
						error: file.hasError
					}]),
            key: i
          }, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(file.file.name), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.formatBytes(file.file.size * file.progress)) + " / " + _toDisplayString(_ctx.formatBytes(file.file.size)) + "    " + _toDisplayString(file.status), 1)
            ]),
            _createElementVNode("div", {
              class: "upload-file-item-progress",
              style: _normalizeStyle(`width:${file.progress * 100}%`)
            }, null, 4)
          ], 2))
        }), 128))
      ])
    ]),
    (!_ctx.uploadFinished)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", null, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t("import.uploadChild.inProgress")) + ".", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("import.uploadChild.leaveOpen")), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}